import axios from 'axios';
import config from './../config';
import store from './../store/store';

export const axiosRequest = (req, hasBaseUrl) => {
  store.dispatch('app/clearErrors');
  const {
    options,
    url,
    lang,
    headers,
    params,
  } = req;
  let { data } = req;
  data = data || {};
  const appLang = lang || 'pl';
  const version = data.version ? data.version : '1.0';
  let axiosUrl = `${config.apiUrl}/api/${version}/${appLang}/app/${url}`;
  if (hasBaseUrl) {
    axiosUrl = url;
  }
  const settings = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    url: axiosUrl,
    data,
    ...options,
    params,
  };

  let isRefreshing = false;
  let refreshinCall = null;

  function refreshToken() {
    if (isRefreshing) {
      return refreshinCall;
    }
    isRefreshing = true;
    refreshinCall = axios.post(`${config.apiUrl}/api/${version}/${appLang}/app/auth/refresh`, { refresh: store.getters['app/refreshToken'] }).then((refreshData) => {
      const refreshedData = refreshData.data.data;
      store.dispatch('app/setTokens', { token: refreshedData.token, refresh: refreshedData.refresh });
      axios.defaults.headers.common.Authorization = `Bearer ${refreshedData.token}`;
      isRefreshing = false;
      refreshinCall = null;
      return Promise.resolve(true);
    });
    return refreshinCall;
  }

  axios.interceptors.response.use(response => response, (error) => {
    if (error.response.status === 404) {
      store.dispatch('app/pageNotFound');
      return false;
    }
    const status = error && error.response ? error.response.status : null;
    if (status === 401) {
      return refreshToken().then(() => {
        error.config.headers.Authorization = `Bearer ${store.getters['app/token']}`;
        return axios.request(error.config);
      });
    }
    return Promise.reject(error);
  });

  return axios(settings).catch((e) => {
    if (!e) return false;
    const res = e.response;
    const { status } = res.data;
    if (status.code !== -10) {
      store.dispatch('app/setError', status.msg);
    }
    if (res.status === 403 && status.code !== -12) {
      store.dispatch('app/clearUserData');
    }
    if (res.status === 403 && status.code === -12) {
      store.dispatch('user/setPasswordRedirect');
    }
    return Promise.reject(e);
  });
};

export const saveToken = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};
